/**
 * Default: Vendors
 */

import VendorsBrandEndorsement from './brand-endorsement';
import VendorsMindshapeCookieConsent from './mindshape-cookie-consent';
import VendorsFancybox from './fancybox';
import VendorsOverlayScrollbars from './overlayscrollbars';
import VendorsModal from './bootstrap/modal';

const index = () => {
	const pageType = document.body.dataset.pageType;

	/* eslint-disable no-console */
	// if (processEnv === 'development') {
	// 	console.log('Vendors');
	// }
	/* eslint-enable no-console */

	VendorsBrandEndorsement().then(result => {
		// Do nothing...
	});

	if (pageType !== 'modal') {
		VendorsMindshapeCookieConsent().then(result => {
		// Do nothing...
	});
	}

	VendorsModal();

	VendorsOverlayScrollbars().then(result => {
		// Do nothing...
	});

	VendorsFancybox().then(result => {
		// Do nothing...
	});
};

export default index;
